import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import moment from 'moment';
import SelectWithLabel from '../selectWithLabel/selectWithLabel';
import './hourRange.less';

class HourRange extends React.Component {
  initialState = {
    selectedProduct: '',
    quantity: 1,
  }

  constructor(props) {
    super(props);

    this.state = this.initialState;
    this.hourRanges = this.generateHourRanges();
  }

  componentDidUpdate(prevProps) {
    const { isToday } = this.props;
    if (prevProps.isToday !== isToday) {
      this.hourRanges = this.generateHourRanges();
      this.forceUpdate();
    }
  }

  generateHourRanges = () => {
    const { isToday } = this.props;
    const currentHour = parseInt(moment().format('H'), 10) + 2;
    const startHour = isToday ? currentHour : 8;
    const hourRanges = [];

    for (let hour = startHour; hour < 17; hour += 1) {
      hourRanges.push({
        start: `${hour}:00`,
        end: `${hour + 2}:00`,
        value: hour,
      });
    }

    return hourRanges;
  };

  selectRange = (e) => {
    const { onSelect } = this.props;
    const selectedRange = e.target.value;

    this.setState({ selectedRange: e.target.value });
    onSelect(selectedRange);
  };

  render() {
    const { error } = this.props;
    const { selectedRange } = this.state;
    return (
      <div className={`hour-range ${error ? 'hour-range--error' : ''}`}>
        <FormControl variant="outlined" fullWidth>
          <SelectWithLabel
            value={selectedRange}
            onChange={this.selectRange}
            required
            label="Wybierz godzinę *"
          >
            {this.hourRanges.map(range => (
              <MenuItem key={range.value} value={range.value}>
                {range.start}
                {' '}
                -
                {' '}
                {range.end}
              </MenuItem>
            ))}
          </SelectWithLabel>
        </FormControl>
      </div>
    );
  }
}

HourRange.propTypes = {
  error: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  isToday: PropTypes.bool.isRequired,
};

HourRange.defaultProps = {
  error: false,
};

export default HourRange;
